import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f013c60a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f013c60a')) {
      api.createRecord('f013c60a', component.options)
    } else {
      api.reload('f013c60a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f013c60a&", function () {
      api.rerender('f013c60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormComponents/Company/index.vue"
export default component.exports